import React from 'react';
import styled from 'styled-components';
import { Badge, spacing, ConditionalWrapper } from '@landr/maestro';
import { t } from '@lingui/macro';

const ResponsiveTopLeft = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    margin-top: ${spacing('xs')};
    margin-left: ${spacing('xs')};
    pointer-events: none;
`;

const TakenDownBadge: React.FC<{
    isAbsolute?: boolean;
}> = ({ isAbsolute = false }) => (
    <ConditionalWrapper
        condition={isAbsolute}
        wrapper={(children: React.ReactNode): React.ReactNode => (
            <ResponsiveTopLeft>{children}</ResponsiveTopLeft>
        )}
    >
        <Badge
            variant="warning"
            kind="subtle"
            content={t`unavailable`}
            size="sm"
            isRounded={true}
        />
    </ConditionalWrapper>
);

export default TakenDownBadge;
